<template>
<form @submit.prevent="submit">
    <div :class="`form-group field-${field.name.replace('_', '-')}`" v-for="field in fieldList">
        <label>{{ field.title }}</label>

        <multi-select v-if="field.type == 'school'"
            v-model="value[field.name]" 
            :disabled="field.disabled"
            @input="val => { onInput(field.name, val) }"
            :label="schoolLabel" 
            :filter="schoolFilter" 
            placeholder="Wähle ein Schule aus"
            url="schools">
            <span slot="noResult">
                Keine Schulen gefunden
            </span>
        </multi-select>

        <city-select v-else-if="field.type == 'city'"
                     v-model="value[field.name]"
                     :disabled="field.disabled"
                     @input="val => { onInput(field.name, val) }" />

        <select v-else-if="field.type == 'select'"
                v-model="value[field.name]" 
                :disabled="field.disabled"
                @input="val => { onInput(field.name, val) }"
                :class="{ 'form-control': 1, 'is-invalid': errors[field.name] }">
            <option v-for="(value, key) in field.options" :value="key">
                {{ value }}
            </option>
        </select>

        <user-select v-else-if="field.type == 'user'"
                     v-model="value[field.name]"
                     :disabled="field.disabled"
                     @input="val => { onInput(field.name, val) }"
                     :placeholder="field.placeholder"
                     :type="field.userType"
                     :multiple="field.multiple" />

        <toggle v-else-if="field.type == 'toggle'"
                v-model="value[field.name]" 
                :disabled="field.disabled"
                @input="val => { onInput(field.name, val) }"
                :choices="field.choices" />

        <photo-upload v-else-if="field.type == 'photos'" 
                      v-model="value[field.name]" 
                      :disabled="field.disabled"
                      @input="val => { onInput(field.name, val) }"
                      mutiple />

        <input v-else-if="field.type == 'number'"
               type="number" 
               inputmode="numeric" 
               pattern="[0-9]*" 
               v-model="value[field.name]" 
               :disabled="field.disabled"
               @input="onInput(field.name, $event.target.value)"
               class="form-control" 
               :min="field.min">

        <textarea v-else-if="field.type == 'textarea'"
                  v-model="value[field.name]" 
                  @input="onInput(field.name, $event.target.value)">
        </textarea>

        <input v-else
               :type="field.type" 
               v-model="value[field.name]" 
               :disabled="field.disabled"
               @input="onInput(field.name, $event.target.value)"
               :class="{ 'form-control': 1, 'is-invalid': errors[field.name] }">

        <div v-if="errors[field.name]" class="invalid-feedback">
            {{ errors[field.name][0] }}
        </div>
    </div>
    <input type="submit" :value="submitLabel" class="btn btn-primary" :disabled="submitting">
    <a v-if="secondaryLabel" href="#" @click.prevent="secondaryAction">
        {{ secondaryLabel }}
    </a>
</form>
</template>

<script>
import _ from 'underscore'
import userSelect from 'components/user-select.vue'
import multiSelect from 'components/multi-select.vue'
import citySelect from 'components/city-select.vue'
import photoUpload from 'components/photo-upload.vue'
import toggle from 'components/toggle.vue'
import base from 'base.vue'

export default {
    mixins: [ base ],
    components: { userSelect, multiSelect, citySelect, photoUpload, toggle },
    props: {
        value:          { type: Object, default: function () { return { } } },
        hiddenFields:   { type: Object, default: function () { return { } } },
        fields:         { type: Array, required: true },
        secondaryLabel: { type: String, default: null },
        submitLabel:    { type: String, required: true },
        url:            { type: String, required: true },
        clearOnSubmit:  { type: Boolean, default: false }
    },
    data () {
        // Generate list of years to choose from

        // School year starts Aug 1st - find year that current school year started in
        const now = new Date
        var lastYear
        if (now > new Date(now.getFullYear(), 8, 1)) {
            lastYear = now.getFullYear()
        } else {
            lastYear = now.getFullYear() - 1
        }

        // Generate options from 1st to 9th grade
        const yearOptions = { }
        for (var n = 0; n < 9; n++) {
            yearOptions[lastYear - n] = (n + 1) + '. Klasse'
        }

        return {
            formData: this.data,
            submitting: false,
            errors: { },
            templates: {
                'username': { title: 'Benutzername', type: 'text' },
                'firstname': { title: 'Vorname', type: 'text' },
                'lastname': { title: 'Nachname', type: 'text' },
                'password': { title: 'Passwort', type: 'password' },
                'password_repeat': { title: 'Passwort wiederholen', type: 'password' },
                'email': { title: 'E-Mail', type: 'email' },
                'firstname': { title: 'Vorname', type: 'text' },
                'lastname': { title: 'Nachname', type: 'text' },
                'motto': { title: 'Motto', type: 'text' },
                'racket': { title: 'Racket', type: 'text' },
                'school': { title: 'Schulhaus', type: 'school', extractId: true },
                'city': { title: 'Ort', type: 'city', extractId: true },
                'yob': { title: 'Jahrgang', type: 'number', min: 1900 },
                'sex': { title: 'Geschlecht', type: 'select', options: { 
                    female: 'Weiblich',
                    male: 'Männlich',
                    na: 'Keine Angabe/Anderes'
                } },
                'handedness': { title: 'Hand', type: 'select', options: { 
                    left: 'Links',
                    right: 'Rechts',
                    na: 'Keine Angabe'
                } },
                'year': { title: 'Klasse', type: 'select', options: yearOptions },
                'active': { title: 'Aktiv', type: 'checkbox' },
                'photos': { title: 'Fotos', type: 'photos' }
            }
        }
    },
    computed: {
        fieldList () {
            // Substitute templates if only a string has been supplied
            const that = this
            return _.map(this.fields, function(field) {
                if (typeof field == 'string') {
                    return _.extend(that.templates[field], { name: field })
                } else {
                    return field
                }
            })
        }
    },
    methods: {
        /*
         * Returns the data to be submitted via HTTP
        */
        getFormData () {
            // Start with hidden fields
            var data = _.clone(this.hiddenFields)

            for (var i = 0; i < this.fieldList.length; i++) {
                const field = this.fieldList[i]

                if (!field.extractId) {
                    // Regular field: copy value
                    data[field.name] = this.value[field.name]
                } else {
                    // Extract id from object
                    const val = this.value[field.name]
                    if (val instanceof Array) {
                        data[field.name + '_id'] = _.map(val, x => x ? x.id : null)
                    } else {
                        data[field.name + '_id'] = val ? val.id : null
                    }
                    
                }
            }

            return data
        },

        /*
         * Clears all fields
        */
        clear () {
            for (var i = 0; i < this.fieldList.length; i++) {
                // TODO: Is null okay?
                // TODO: Defaults
                this.value[this.fieldList[i].name] = null
            }
        },

        submit () {
            this.submitting = true

            const that = this
            this.$api.post(this.url, this.getFormData())
            .then(response => {
                that.submitting = false
                that.errors = { }

                if (that.clearOnSubmit) {
                    that.clear()
                }

                that.$emit('submitted', response)
            })
            .catch(error => {
                that.submitting = false
                
                // Clear previous errors
                that.errors = { }

                // Show validation errors, if any
                if (error.response && error.response.data.errors) {
                    // Remove `_id` suffix from error keys
                    that.errors = _.object(_.map(_.pairs(error.response.data.errors), pair =>
                        [ pair[0].replace('_id', ''), pair[1] ]))
                // Otherwise, show error message, if any
                } else if (error.response && error.response.data.message) {
                    that.flash('Fehler: ' + error.response.data.message, 'error')
                }
            })
        },
        secondaryAction () {
            this.$emit('secondary', this.formData)
        },
        schoolLabel ({ name }) {
            return name
        },
        schoolFilter (school, query) {
            return school.name.toLowerCase().indexOf(query) != -1
        },
        /*
         * Emit `input` event for `v-model` to work
        */
        onInput (field, value) {
            this.$emit('input', this.value)
        }
    }
}
</script>



// WEBPACK FOOTER //
// custom-form.vue?fbd3aa78